import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Treatments } from "@/components/site/Treatments";
import { PriceTeaser } from "@/components/site/PriceTeaser";
import { About } from "@/components/site/About";
import { Booking } from "@/components/site/Booking";
import { Contact } from "@/components/site/Contact";
import { scrollToId } from "@/lib/scroll";
import { usePageMeta } from "@/lib/usePageMeta";

export default function Home({ treatment, onSelect, onOpenPrivacy }) {
  usePageMeta(
    "Fachfußpflege & Wellness in Bensheim | Maison Princess",
    "Fachfußpflege, koreanische Gesichtsbehandlungen, Massagen und G8 Body Contouring in Bensheim. Termin ganz einfach per E-Mail anfragen.",
    "/",
  );
  const location = useLocation();

  useEffect(() => {
    const id = location.state?.scrollTo || location.hash.slice(1);
    if (!id) return undefined;
    const t = setTimeout(() => scrollToId(id), 400);
    return () => clearTimeout(t);
  }, [location]);

  const select = (title) => {
    onSelect(title);
    scrollToId("termin");
  };

  return (
    <>
      <Hero />
      <Marquee />
      <Treatments onSelect={select} />
      <PriceTeaser />
      <About />
      <Booking preselect={treatment} onOpenPrivacy={onOpenPrivacy} />
      <Contact />
    </>
  );
}
